export enum DeliveryProductTypeDto {
  FullVersion = 'fullVersion',
  ServiceRelease = 'serviceRelease',
  Hotfix = 'hotfix',
}
